<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    title,
    lede = null,
    align = "start",
    level = 2,
    aside,
  }: {
    title: string;
    lede?: string | null;
    align?: "start" | "center";
    level?: 1 | 2;
    aside?: Snippet;
  } = $props();
</script>

<header
  class={[
    "flex gap-x-16 gap-y-6",
    align === "center"
      ? "flex-col items-center text-center"
      : "flex-col items-start md:flex-row md:items-end md:justify-between",
  ]}
>
  <div
    class={["flex max-w-3xl flex-col gap-5", align === "center" ? "items-center" : "items-start"]}
  >
    <svelte:element
      this={level === 1 ? "h1" : "h2"}
      class={["font-semibold whitespace-pre-line text-ink-1", level === 1 ? "title-1" : "title-2"]}
      >{title}</svelte:element
    >
    {#if lede !== null}
      <p class="max-w-2xl text-bar leading-7 text-pretty text-ink-2">
        {lede}
      </p>
    {/if}
  </div>
  {#if aside !== undefined}
    <div class="shrink-0">{@render aside()}</div>
  {/if}
</header>

<style>
  .title-1 {
    font-size: clamp(2.75rem, 6.4vw, 5rem);
    line-height: 0.98;
    letter-spacing: -0.05em;
    text-wrap: balance;
  }

  .title-2 {
    font-size: clamp(2rem, 4.2vw, 3.5rem);
    line-height: 1.02;
    letter-spacing: -0.045em;
    text-wrap: balance;
  }
</style>
